import React from 'react'
import styled from 'styled-components'
import { isNumber } from 'lodash'

import Text from '~/views/components/ui/Text'
import LocalizedCurrencyNumber from '~/views/components/currency/LocalizedCurrencyNumber'
import { useCurrentUserContext } from '~/views/contexts/CurrentUserContext'
import { getCurrencySymbol } from '~/utils/currency/currency'
import { LoadingTextPlaceholder } from '~/views/components/ProjectOverview/components/ProjectOverviewCard'
import { useStaticLabels } from 'shared/hooks/use-static-labels'

const AccruedBilledContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

type AccruedBilledContentProps = {
  accruedBilled?: number | null
  loading: boolean
}

export default function AccruedBilledContent({
  accruedBilled,
  loading,
}: AccruedBilledContentProps) {
  const [getCommonLabel] = useStaticLabels(['common'])

  return (
    <AccruedBilledContentContainer data-component-name="accrued-billed-container">
      <Text data-component-name="accrued-billed-label">
        {getCommonLabel('chargesAccrued')}
      </Text>

      <AccruedBilledContentValue
        accruedBilled={accruedBilled}
        loading={loading}
      />
    </AccruedBilledContentContainer>
  )
}

/**
 * =====----===--=--===----=====
 * AccruedBilledContentValue
 */

type AccruedBilledContentValueProps = {
  accruedBilled?: number | null
  loading: boolean
}

function AccruedBilledContentValue({
  accruedBilled,
  loading,
}: AccruedBilledContentValueProps) {
  const { currentUser } = useCurrentUserContext()

  if (loading) {
    return <LoadingTextPlaceholder />
  }

  return !isNumber(accruedBilled) ? (
    <DefaultAccruedBilledContentValue />
  ) : (
    <Text weight="bold" data-component-name="accrued-billed-value">
      <LocalizedCurrencyNumber
        number={accruedBilled as number}
        currentUser={currentUser}
      />
    </Text>
  )
}

/**
 * =====----===--=--===----=====
 * DefaultAccruedBilledContentValue
 */

function DefaultAccruedBilledContentValue() {
  const { currentUser } = useCurrentUserContext()

  return (
    <Text
      data-component-name="accrued-billed-value"
      data-testid="accrued-default-billed-value"
    >
      <Text weight="bold">
        {getCurrencySymbol(currentUser?.organization?.currencyCode)} -
      </Text>
    </Text>
  )
}
